module.exports = __webpack_public_path__ + "static/media/bandeira_hiper.df90f571.svg";